export default __webpack_public_path__ + "static/media/ornek_toplu_isten_cikis.8c65840f.xlsx";